import { API } from 'service/API'

import { INetworkServiceInterface } from '../NetworkService'
import { ILocationModelJSON, ILocationResJSON } from './LocationsModel'

export class LocationsService implements INetworkServiceInterface {
  API: API

  constructor(api: API) {
    this.API = api
  }

  getAll = (): Promise<ILocationResJSON> => {
    return this.API.network.locations.getLocations()
  }

  get = (_id: string): Promise<ILocationModelJSON> => {
    return this.API.network.locations.getLocation(_id)
  }

  findByIds = (_ids: string[]): Promise<ILocationModelJSON[]> => {
    if (!_ids.length) {
      return Promise.resolve([])
    }
    return this.API.network.locations.getManyLocation(_ids.join(','))
  }

  search = (searchText: string): Promise<ILocationResJSON> => {
    return this.API.network.locations.searchLocation(searchText)
  }

  save = (location: Partial<ILocationModelJSON>): Promise<ILocationModelJSON> => {
    return this.API.network.locations.saveLocation(location)
  }

  delete = (locationId: string) => {
    return this.API.network.locations.deleteLocation(locationId)
  }
}
